export enum PAGE_ID {
  AWB_GENERAL = -1,
  GENERAL = 0,
  RATE_CLASS = 2,
  RATE_CLASS_EDIT = 3,
  RATE_CLASS_CUSTOMIZE_EDIT = 4,
  RATE_CLASS_NEW = 26,
  RATE_CLASS_EDIT_NEW = 27,
  PRICING = 5,
  AWB = 7,
  AWB_REFUND = 33,
  // SUBMIT_RECEIPT = 29,
  AWB_TEMPRORARY = 9,
  AWB_RESERVED = 48,
  AWB_FORM = 8,
  AIR_PORT = 14,
  AIR_PORT_FORM = 15,
  ORIGIN_DESTINATION = 16,
  ORIGIN_DESTINATION_FORM = 17,
  ROUTE = 18,
  ROUTE_FORM = 19,
  CARGO_COST = 20,
  ISSUER_AWB = 24, //?
  HANDLING_SERVICE_COST = 30,
  APPROVED_RECIEPT = 32,
  //Dashboard
  USER = 34,
  ROLE = 36,
  LEVEL = 37,
  DASHBOARD = 31,
  CCA = 35,
  TRANSACTIONS = 38,
  __RETURN_MONEY = 39,
  //////////////////////////////////////////////////////
  //////////////////////////////////////////////////////
  //////////////////////////////////////////////////////
  //////////////////////////////////////////////////////
  //////////////////////////////////////////////////////
  //////////////////////////////////////////////////////
  //////////////////////////////////////////////////////
  //////////////////////////////////////////////////////
  REPORT = 41,
  VOID_CONFIRMATION = 42,
  ISSUED_AWB = 43,
  DRAFTED_AWB = 44,
  TEMPORARY_AWB = 45,
  CCA_AWB = 35,
  SUBMIT_RECEIPT = 46,
  CHECK_RECEIPT = 47,
  REQUEST_REFUND_OR_VOID = 33,
  CONFORM_REFUND_OR_VOID = 42,
  RETURN_MONEY = 39,
  RESERVED_AWB = 999,
  CHARGE_USER = 49,
  CustomizeRateClass = 50,
  OnlineCharge = 51,
  Manifest = 52,
  PaymentReport = 52,
  USER_SETTINGS = 53,
  USER_CHARGE_DETAIL = 54,
  RTRD = 57,
}
